import React from "react";
import FundTransferList from "./FundTransferCreate";
import configData from "../appconfig/config.json";

class FundTransferView extends React.Component {
  state = {
    FundTransferDetails: [
      {
        index: Math.random(),
        transferFrom: "",
        CreditAcntNO: "",
        CreditAbleAcntNO: "",
        pricing: "",
        transferto: "",
        Nameancnt: "",
        CreditCardnumber: "",
        Amount: "",

      }
    ]
  };


  handleChange = e => {
    if (
      ["transferFrom",
        "CreditAcntNO",
        "CreditAbleAcntNO",
        "pricing",
        "transferto",
        "Nameancnt",
        "CreditCardnumber", "Amount"].includes(
          e.target.name
        )
    ) {
      let FundTransferDetails = [...this.state.FundTransferDetails];
      FundTransferDetails[e.target.dataset.id][e.target.name] = e.target.value;

    } else {
      this.setState({ [e.target.name]: e.target.value });
    }
  };

  addNewRow = e => {
    this.setState(prevState => ({

      FundTransferDetails: [
        ...prevState.FundTransferDetails,
        {
          index: Math.random(),
          transferFrom: "",
          CreditAcntNO: "",
          CreditAbleAcntNO: "",
          pricing: "",
          transferto: "",
          Nameancnt: "",
          CreditCardnumber: "",
          Amount: ""
        }
      ]

    }));

  };

  deteteRow = index => {
    this.setState({
      FundTransferDetails: this.state.FundTransferDetails.filter(
        (s, sindex) => index !== sindex
      )
    });

  };

  clickOnDelete(delrecord) {
    configData.AddActiontohide = true;
    this.setState({
      FundTransferDetails: this.state.FundTransferDetails.filter(r => r !== delrecord)
    });

  }
  render() {

    let { FundTransferDetails } = this.state;
    return (
      <div className="content">

        <FundTransferList
          add={this.addNewRow}
          delete={this.clickOnDelete.bind(this)}
          FundTransferDetails={FundTransferDetails}
        />


      </div>
    );
  }
}
export default FundTransferView;
